import React from 'react';

export const PagesTab = () => <p>Coming soon</p>;
